import { NgModule } from '@angular/core';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { TamasAlunoService } from '../tamas-aluno.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AlertaSimplesDialog } from '../alerta-simples';
import { AlertaInputDialog } from '../alerta-input';
import { Location } from '@angular/common';

declare var FB: any;
declare function infoLogado(): any;

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit {
    @ViewChild("inputEmail") meuInputEmail: ElementRef;
    @ViewChild("inputSenha") meuInputSenha: ElementRef;
    nome: any = '';
    telefone: any = '';
    email: any = '';
    senha: any = '';
    newsletter: boolean = true;
    shouldHide: boolean = true;
    shouldHide1: boolean = false;
    shouldHide2: boolean = true;
    shouldHide3: boolean = true;
    nomeCliente: any = '';
    hideLoginLoad: boolean = true;
    meusDados: any = '';
    dadosRecuperar: any = '';
    tentativasFail: any = 0;
    idCliente: any = 0;
    passoAtual: any = '';
    constructor(public tmaService: TamasAlunoService, public router: Router, public dialog: MatDialog, private _location: Location) { }

    ngOnInit() {
        setTimeout(() => {
            if (this.tmaService.logado == true) {
                this.router.navigate(['home']);
            }
            else {
                this.passoAtual = 'email';
                if (this.tmaService.paginaAnterior == 'cart/') {
                    const avisoLogar = this.dialog.open(AlertaSimplesDialog, {
                        // width: '250px',
                        disableClose: true,
                        data: { textoAlerta: "Você deve efetuar o <b>login</b> para realizar o pedido.<br>Caso seja sua primeira vez aqui <b>efetue seu cadastro, é rápido!</b>" }
                    });
                }
            }

        }, 0);

        //fblogin
        // (window as any).fbAsyncInit = function () {
        //     FB.init({
        //         appId: '1645426582405847',
        //         cookie: true,
        //         xfbml: true,
        //         version: 'v3.1'
        //     });
        //     FB.AppEvents.logPageView();
        // };

        // (function (d, s, id) {
        //     var js, fjs = d.getElementsByTagName(s)[0];
        //     if (d.getElementById(id)) { return; }
        //     js = d.createElement(s); js.id = id;
        //     js.src = "https://connect.facebook.net/en_US/sdk.js";
        //     fjs.parentNode.insertBefore(js, fjs);
        // }(document, 'script', 'facebook-jssdk'));
    }

    // submitLogin() {
    //     console.log("submit login to facebook");
    //     // FB.login();
    //     FB.login((response) => {
    //         console.log('submitLogin', response);
    //         console.log(response.authResponse.accessToken);
    //         if (response.authResponse) {
    //             const fbUserId = response.authResponse.userID;
    //             FB.api(fbUserId, 'GET', { "fields": "id,name,email,first_name,picture" }, function (res) {
    //                 // Insert your code here
    //                 console.log(res);
    //                 localStorage["mp_DadosUsuario"] = JSON.stringify({ nome: res['name'], profileId: res['id'], foto: res['picture'].data.url });
    //             });
    //             console.log("logado");

    //             this.tmaService.logado = true;
    //             if (this.tmaService.paginaAnterior !== '') {
    //                 this.router.navigate([this.tmaService.paginaAnterior]);
    //             }
    //             else {
    //                 this.router.navigate(['minhaconta/']);
    //             }
    //             //login success
    //             //login success code here
    //             //redirect to home page
    //         }
    //         else {
    //             console.log('User login failed');
    //         }
    //     });

    // }

    logar(): void {
        console.log(this.email);
        console.log(this.senha);
      
        if (this.passoAtual == 'senha') {
            var qToken = [];
            var qUserAgent = "";
            var meuToken = "";
            if (localStorage.getItem('tmsToken') != null) {
                qToken = JSON.parse(localStorage.getItem('tmsToken'));
                meuToken = qToken['token'];
              }
              
              console.log(window.navigator.userAgent);
              console.log(/Macintosh|iPad|iPhone/.test(window.navigator.userAgent));
              if(/Macintosh|iPad|iPhone/.test(window.navigator.userAgent)){
                qUserAgent = "Safari";
              }
              else{
                qUserAgent = "Web";
              }

              if(meuToken == ''){
                if(localStorage.getItem('tmsMerge') != null){
                  var dadosMerge = [];
                  dadosMerge = JSON.parse(localStorage.getItem('tmsMerge'));
                  meuToken = dadosMerge['token'];
                  qUserAgent = dadosMerge['so'];
                  this.tmaService.hcSO = dadosMerge['so'];
                }
              }
            let customParams = {
                email: this.email,
                senha: this.senha,
                token: meuToken,
                so: qUserAgent
            };
            this.hideLoginLoad = false;
            this.tmaService.getLogin(customParams)
                .subscribe((qDados) => {
                    this.hideLoginLoad = true;
                    console.log(qDados);
                    if (qDados.length == 0) {
                        // console.log("Algo errado");
                        // this.hideLoginLoad = true;
                        // const erroInternet = this.dialog.open(AlertaSimplesDialog, {
                        //     width: '250px',
                        //     data: {textoAlerta: "<b>Por favor verifique sua conexão com a internet</b>"}
                        // });
                        // return;

                    }
                    if (qDados['res'] == 'done') {
                        
                        this.tmaService.logado = true;
                        //this.tmaService.logadoNome = qDados['nome'];
                        this.tmaService.hcEmail = this.email
                        this.tmaService.hcSenha = this.senha;
                        this.tmaService.hcNomeUsuario = qDados['nomeusuario'];
                        this.tmaService.hcNome = qDados['nomefull'];
                        this.tmaService.hcFoto = qDados['foto'];
                        this.tmaService.hcIsPro = qDados['isPro'];
                        this.tmaService.hcTreinoFix = qDados['treinoFix'];
                        this.tmaService.hcDietaFix = qDados['dietaFix'];
                        this.tmaService.hcProAtivo = qDados['statusPro'];
                        this.tmaService.hcPremium = qDados['statusPremium'];
                        this.tmaService.notifyQtyhange.next(qDados['numNotify']);
                        this.tmaService.hcUid = qDados['uid'];
                        if (qDados['tema'] == 'light') {
                            this.tmaService.setDarkTheme(false);
                        }
                        else {
                            this.tmaService.setDarkTheme(true);
                        }

                        localStorage.removeItem("tmsDadosCliente");
                        localStorage["tmsDadosCliente"] = JSON.stringify({ email: this.email, senha: this.senha });
                        console.log("logado");
                        infoLogado();
                        if (qDados['status'] == true) {
                            this.tmaService.hcEtapa = 8;
                            if (this.tmaService.paginaAnterior !== '') {
                                this.router.navigate([this.tmaService.paginaAnterior]);
                            }
                            else {
                                this.router.navigate(['/home']);
                            }
                        }
                        else {
                            this.tmaService.hcEmail = this.email;
                            this.router.navigate(['meu-cadastro/s/' + qDados['etapaCad'] + '/'  + qDados['uid'] + '/' + qDados['codigo']]);
                        }
                       
                    }
                    else {
                        //invalid
                        if(qDados['res'] == 'incorrect'){
                            const erroPW = this.dialog.open(AlertaSimplesDialog, {
                                disableClose: true,
                                data: { textoAlerta: "Senha incorreta. Verifique a senha digitada e tente novamente", iconAlerta: 'warning' }
                            });
                        }
                        //this.router.navigate(['/login']);
                    }
                },
                    (error) => {
                        this.hideLoginLoad = true;
                        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                            disableClose: true,
                            data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
                        });
                    });
        }
        if (this.passoAtual == 'email') {
            //check email server
            this.hideLoginLoad = false;
            let customParams = {
                //lista: localStorage.getItem('turboCart'),
                email: this.email
            };
            this.tmaService.checkUserEmail(customParams)
                .subscribe((qRes) => {
                    this.hideLoginLoad = true;
                    if (qRes['res'] == 'done') {
                        if (qRes['status'] == true) {
                            this.passoAtual = 'senha';
                            setTimeout(() => {
                                this.meuInputSenha.nativeElement.focus();
                            }, 300);
                        }
                        else {
                            if (qRes['etapaCad'] == 1) {
                                this.tmaService.hcEmail = this.email;
                                this.router.navigate(['meu-cadastro/s/' + qRes['etapaCad'] + '/'  + qRes['uid'] + '/' + qRes['codigo']]);
                            }
                            else {
                                //autenticar primeiro
                                this.passoAtual = 'senha';
                                setTimeout(() => {
                                    this.meuInputSenha.nativeElement.focus();
                                }, 300);
                            }
                        }
                    }
                    else {
                        if(qRes['res'] == 'invalid'){
                            this.hideLoginLoad = true;
                            const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                                disableClose: true,
                                data: { textoAlerta: "E-mail não cadastrado, verifique se digitou corretamente.", iconAlerta: 'warning' }
                            });
                        }
                        else{
                            this.hideLoginLoad = true;
                            const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                                disableClose: true,
                                data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
                            });
                        }
                        
                    }
                },
                    (error) => {
                        this.hideLoginLoad = true;
                        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                            disableClose: true,
                            data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
                        });
                    })

        }
    }
    recuperarPass(): void {
        var fraseRecuperar = "";
        fraseRecuperar = "Insira abaixo o seu e-mail que nós enviaremos a senha"

        const dialogRecuperarP = this.dialog.open(AlertaInputDialog, {
            disableClose: true,
            width: '300px',
            data: { tituloAlerta: "Esqueceu sua senha", nomeInput: 'email', textoAlerta: fraseRecuperar, textoInput: "E-mail", tipoInput: "email", valorInput: this.email, textoCancel: "Cancelar", textoConfirm: "Confirmar" }
        });
        dialogRecuperarP.afterClosed().subscribe(resultInp => {
            console.log('The dialog was closed');
            console.log(resultInp);
            if (resultInp == false) {
                return;
            }
            if (resultInp == '') {
                //false
                const emailNulo = this.dialog.open(AlertaSimplesDialog, {
                    width: '250px',
                    data: { textoAlerta: "Você deve digitar um e-mail válido para recuperar sua senha!" }
                });
                console.log("E-mail inválido");
                return;
            }
            else {
                //faz a chamada para recuperar a senha
                this.hideLoginLoad = false;
                let customParams = {
                    //lista: localStorage.getItem('turboCart'),
                    email: resultInp
                };
                this.tmaService.goRecuperar(customParams)
                .subscribe((qRes) => {
                    this.hideLoginLoad = true;
                    if (qRes['res'] == 'invalid') {
                        const algoErrado3 = this.dialog.open(AlertaSimplesDialog, {
                            width: '250px',
                            data: { textoAlerta: "E-mail não encontrado no sistema!" }
                        });
                    }
                    else if (qRes['res'] == 'ok') {
                        const recDone = this.dialog.open(AlertaSimplesDialog, {
                            width: '250px',
                            data: { textoAlerta: "Em instantes você receberá um e-mail com as instruções para alterar sua senha" }
                        });
                    }
                    else{
                        this.hideLoginLoad = true;
                        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                            disableClose: true,
                            data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
                        });
                    }
                },
                    (error) => {
                        this.hideLoginLoad = true;
                        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                            disableClose: true,
                            data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
                        });
                    })
            }

        });
    }
    goCad(): void {
        this.router.navigate(['cadastrar/']);
    }
    voltar(): void {
        // this._location.back();

        if (this.passoAtual == 'senha') {
            this.passoAtual = 'email';
            setTimeout(() => {
                this.meuInputEmail.nativeElement.focus();
            }, 100);
        }
        else {
            this.router.navigate(['autenticar/']);
        }
    }
}
